<div class="scroll-to-top" [class.show-scrollTop]="windowScrolled" [class.scrolled-bottom]="scrolledBottom">
    <button type="button" class="primary" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <fa-icon [icon]="scrollIcon"></fa-icon>
    </button>
</div>